<template>
  <v-card class="pa-2" flat>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="valueComputed.title"
          outlined
          dense
          :label="$t('title')"
        ></v-text-field>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: "FloorSetting",
  props: {
    value: Object,
  },

  computed: {
    valueComputed: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>

<style></style>
